const PASSPORT_REGEX = /^(?!^0+$)[a-zA-Z0-9]{6,12}$/;

export function isValidPassport(passport: string): boolean {
  return PASSPORT_REGEX.test(passport.toUpperCase());
}
